module.exports = __webpack_public_path__ + "img/fuwubaoz_4.a4854e97.png";